"use client";

import {
  useFloating,
  offset,
  shift,
  arrow as floatingArrow,
  hide, // 👈 sorgt fürs Ausblenden
  autoUpdate,
  useInteractions,
  useRole,
  FloatingPortal,
} from "@floating-ui/react";
import { cloneElement, useRef } from "react";
import Image from "next/image";
import useIsMobile from "@/hooks/useIsMobile";
import errorIcon from "@/assets/svgs/error.svg";
import "./ErrorTooltip.css";

export default function ErrorTooltip({ children, message, visible }) {
  const isMobile = useIsMobile();
  const arrowRef = useRef(null);

  /* Floating UI ------------------------------------------------- */
  const { refs, floatingStyles, placement, middlewareData, context } =
    useFloating({
      placement: isMobile ? "bottom" : "right",
      strategy: "absolute", // Tooltip folgt dem Feld
      whileElementsMounted: autoUpdate,
      middleware: [
        offset(isMobile ? 8 : 20),
        floatingArrow({ element: arrowRef, padding: 6 }),
        hide({ strategy: "referenceHidden" }), // 👈 blendet aus, wenn Feld nicht sichtbar
      ],
    });

  const { getReferenceProps, getFloatingProps } = useInteractions([
    useRole(context, { role: "tooltip" }),
  ]);

  if (!children || typeof children !== "object") return null;

  /* Flag aus der hide‑Middleware */
  const isHidden = middlewareData.hide?.referenceHidden ?? false;

  const staticSide = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right",
  }[placement.split("-")[0]];

  /* Render ------------------------------------------------------- */
  return (
    <>
      {cloneElement(children, {
        ref: refs.setReference,
        ...getReferenceProps(),
      })}

      {visible && (
        <FloatingPortal>
          <div
            ref={refs.setFloating}
            style={{ ...floatingStyles, maxWidth: 260 }}
            className={`tooltip-error ${isHidden ? "fade-out" : "fade-in"}`}
            {...getFloatingProps()}
          >
            <Image src={errorIcon} alt="error" className="error-tooltip-icon" />
            {message}
            <span
              ref={arrowRef}
              className="tooltip-error-arrow"
              style={{
                position: "absolute",
                left: middlewareData.arrow?.x ?? "",
                top: middlewareData.arrow?.y ?? "",
                [staticSide]: "-5px",
              }}
            />
          </div>
        </FloatingPortal>
      )}
    </>
  );
}
